import { IFormQuestion } from './form-type.interface';

export type FormResponseStatysType = 'PENDING' | 'APPROVED' | 'REJECTED';

export enum FormResponseEnum {
  PENDING = 'Pendiente',
  APPROVED = 'Aprobado',
  REJECTED = 'Rechazado'
}

export interface IFormResponseCustomer {
  id: string;
  name: string;
  email: string;
  number: string;
  business: {
    id: string;
    name: string;
    ruc: string;
  };
}

export interface IFormResponseFormType {
  id: string;
  approvalMessage: string;
  disapprovalMessage: string;
}

export interface IFormResponse {
  id: string;
  code: string;
  status: string;
  creationDate: Date;
  finishDate?: Date;
  time: number;
  customer: IFormResponseCustomer;
  formType: IFormResponseFormType;
}

export interface IFormPhoneValidationReq {
  phoneNumber: string;
}

interface IResponseReq {
  questionId: string;
  answer: string;
}

export interface IFormResponseReq {
  customerId: string;
  responses: IResponseReq[];
}

export interface IFormResponseRes {
  id: string;
  answer: string;
  question: IFormQuestion;
}

export interface IFormResponseDetail extends IFormResponse {
  responses: IFormResponseRes[];
}

export interface IPatchFormResponseReq {
  status?: 'APPROVED' | 'REJECTED';
}
